import clsx from 'clsx';
import React from 'react';
import { JobState } from '@biolibtech/biolib-js';

const stateColorClasses: Record<JobState | 'error', string> = {
    [JobState.awaitingInput]: 'bg-gray-100 text-gray-800',
    [JobState.cancelled]: 'bg-gray-100 text-gray-800',
    [JobState.completed]: 'bg-emerald-100 text-emerald-800',
    [JobState.failed]: 'bg-red-100 text-red-800',
    [JobState.inProgress]: 'bg-blue-100 text-blue-800',
    error: 'bg-red-100 text-red-800',
};

interface IProps {
    state: string;
}

export default function StateTag(props: IProps) {
    const { state } = props;
    const colorClasses = stateColorClasses[state] ?? 'bg-gray-100 text-gray-800';

    return (
        <span
            className={clsx('capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full', colorClasses)}
        >
            {state === 'in_progress' ? 'Pending' : state.replaceAll('_', ' ')}
        </span>
    );
}
